// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PQuestionCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PQuestionCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PQuestionCircleOutlined = function PQuestionCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PQuestionCircleOutlinedSvg
  }));
};

PQuestionCircleOutlined.displayName = 'PQuestionCircleOutlined';
export default React.forwardRef(PQuestionCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PQuestionCircleOutlined.js
// module id = 3568
// module chunks = 0